export enum ReportKey {
  VehicleUsageVatSettlementReport = 'vehicleUsageVatSettlement',
  VehicleUsageReport = 'companycarusage',
  UnitHistoryReport = 'companycarunithistory',
  RoadReport = 'road',
  FleetStatusReport = 'fleetstatus',
  WorkCardReport = 'workcard',
  UnitsWorkCardSummaryReport = 'workcardsummary',
  FuelReport = 'fuel',
  PrivateUseReport = 'unitprivateuse',
  IdlingReport = 'unitidling',
  DataContinuityReport = 'datacontinuity',
  ClientAccumulatedMillageReport = 'accumulatedmillage',
  WinterReport = 'winter',
  ZoneVisitsReport = 'zonevisits',
  StopsReport = 'stops',
  DailyRoadReport = 'dailyroad',
  Psg10Report = 'psg10',
  Psg10AReport = 'psg10A',
  Psg12Report = 'psg12',
  OverspeedingReport = "overspeeding",
  TasksReport = "tasks",
  CorporateUsageSummaryReport = "corporateusagesummary",
  DriverWorkCardReport = "driverworkcard",
  TripsReport = 'trips',
  MileageReport = "mileage",
  FuelingStationReport = 'fuelingstation',
  BorderCrossingReport = 'bordercrossing'
}
